function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.421 2.121L8.465 16.078 2.121 9.734",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
});

var SvgCheckTrue = function SvgCheckTrue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.543,
    height: 17.578
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNC41NDMiIGhlaWdodD0iMTcuNTc4IiB2aWV3Qm94PSIwIDAgMjQuNTQzIDE3LjU3OCI+CiAgPHBhdGggaWQ9ImNoZWNrIiBkPSJNMjQuMyw2LDEwLjM0NCwxOS45NTcsNCwxMy42MTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xLjg3OSAtMy44NzkpIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIzIi8+Cjwvc3ZnPgo=";
export { SvgCheckTrue as ReactComponent };